import React from 'react'

function Preloader() {
    return (
        <>
            {/* Start Preloader Area */}
            <div className="preloader-area text-center position-fixed top-0 bottom-0 start-0 end-0" id="preloader">
                <div className="loader position-absolute start-0 end-0">
                    <div className="wavy position-relative fw-light">
                        <span className="d-inline-block">I</span>
                        <span className="d-inline-block">F</span>
                        <span className="d-inline-block">E</span>
                        <span className="d-inline-block">P</span>
                        <span className="d-inline-block">A</span>
                        <span className="d-inline-block">Y</span>
                    </div>
                </div>
            </div>
            {/* End Preloader Area */}

        </>
    )
}

export default Preloader
